export default "{\n    \"label\": \"Incident en cours\",\n    \"options\": {\n        \"true\": \"A un incident en cours\"\n    }\n}\n"